import { AddCircle } from '@material-ui/icons';
import { Grid } from '@material-ui/core';
import { rhythm } from 'Themes/typography';
import { API_ROOT } from '../../../../../../../api/Routes';
import React from 'react';
import styled from 'styled-components';

import ClearImage from '../components/ClearImage';
import FieldError from '../components/FieldError';

const Container = styled.div`
  border-right: 1px solid ${({ theme }) => theme.palette.blue.light};
  padding: ${rhythm(0.3)} ${rhythm(0.5)} ${rhythm(1)} 0;
  position: relative;
  height: 100%;
`;
const InnerContainer = styled.div`
  position: relative;
`;
const Heading = styled.h1`
  font-size: 1rem;
  ${({ noTitle }) => noTitle && `margin-bottom: 2.25rem;`};
`;

const PhotoPlaceHolder = styled.div`
  position: relative;
  //min-height: 14.5625rem;
  height: 14.5625rem;
  background: #fff;
  border: 2px dashed ${({ theme }) => theme.palette.blue.main};
  color: ${({ theme }) => theme.palette.primary.main};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4);
  width: 100%;

  ${props =>
    !props.isTicketExpired
      ? `
  
  &:hover {
    background: transparent !important;
    cursor: pointer;
    transition: background 200ms ease-in;
  }
  
  `
      : null};
`;

const CustomAddIcon = styled(AddCircle)`
  &&& {
    width: 2.5rem;
    height: 2.5rem;
  }
`;
const AddPhotoText = styled.div`
  font-size: 1.125rem;
  font-weight: 600;
  color: initial;
`;
const FileInput = styled.input.attrs({
  type: 'file',
  accept: 'image/jpeg, image/png',
})`
  width: 100%;
  height: 100%;
  opacity: 0;
  display: block;
  position: absolute;
  top: 0;
  left: 0;

  &:hover:not(:disabled) {
    cursor: pointer;
  }
`;
const Image = styled.img`
  // max-height: 18rem;
  // width: 100%;
  // margin-bottom: 0;
  max-height: 100%;
  max-width: 100%;
`;

const FieldImageName = styled.div`
  margin-top: 10px;
  font-size: 0.75rem;
  color: grey;
  font-weight: 300;
`;

const ImgGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

function getImageSrc(photo) {
  return photo && photo.startsWith('data:image')
    ? photo
    : `${API_ROOT}/asset/${photo}`;
}

const AddPhoto = ({
  photoRef,
  photo1Ref,
  photo2Ref,
  photo,
  photo1,
  photo2,
  onAddPhoto,
  onPhotoClear,
  error,
  noTitle,
  isTicketExpired,
  shortlisted,
  isSlipDiscarded,
}) => (
  <Container>
    <Heading noTitle={noTitle}>
      {!noTitle ? (
        <div>
          {shortlisted
            ? Boolean(photo) && Boolean(photo1) && Boolean(photo2)
              ? 'Change files'
              : 'Add new files'
            : 'Add new photos'}
        </div>
      ) : (
        <div />
      )}
      {error && <FieldError>{`*${error}`}</FieldError>}
    </Heading>
    <Grid container spacing={16}>
      <ImgGrid item xs={12} md={6}>
        <InnerContainer>
          {photo ? (
            <ClearImage
              biggerImage={photo}
              onClick={onPhotoClear(shortlisted ? 'luminaireImage' : 'photo')}
              disabled={isSlipDiscarded}
            />
          ) : null}
          {photo ? (
            <Image src={getImageSrc(photo)} />
          ) : (
            <PhotoPlaceHolder isTicketExpired={isTicketExpired}>
              <FileInput
                name={shortlisted ? 'luminaireImage' : 'photo'}
                onChange={onAddPhoto}
                innerRef={photoRef}
                disabled={isSlipDiscarded}
              />
              <CustomAddIcon />
              <AddPhotoText>
                {shortlisted ? 'Luminaire image' : 'Add photo'}
              </AddPhotoText>
            </PhotoPlaceHolder>
          )}
        </InnerContainer>
        {shortlisted ? <FieldImageName>Luminaire image</FieldImageName> : null}
      </ImgGrid>
      <ImgGrid item xs={12} md={6}>
        <InnerContainer>
          {photo1 && (
            <ClearImage
              biggerImage={photo1}
              onClick={onPhotoClear(
                shortlisted ? 'polarDiagramImage' : 'photo1'
              )}
              disabled={isSlipDiscarded}
            />
          )}
          {photo1 ? (
            <Image src={getImageSrc(photo1)} />
          ) : (
            <PhotoPlaceHolder isTicketExpired={isTicketExpired}>
              <FileInput
                name={shortlisted ? 'polarDiagramImage' : 'photo1'}
                onChange={onAddPhoto}
                innerRef={photo1Ref}
                disabled={isSlipDiscarded}
              />
              <CustomAddIcon />
              <AddPhotoText>
                {shortlisted ? 'Polar diagram' : 'Add photo'}
              </AddPhotoText>
            </PhotoPlaceHolder>
          )}
        </InnerContainer>
        {shortlisted ? <FieldImageName>Polar Diagram</FieldImageName> : null}
      </ImgGrid>
      <ImgGrid item xs={12} md={6}>
        <InnerContainer>
          {photo2 ? (
            <ClearImage
              biggerImage={photo2}
              onClick={onPhotoClear(shortlisted ? 'dimensionsImage' : 'photo2')}
              disabled={isSlipDiscarded}
            />
          ) : null}
          {photo2 ? (
            <Image src={getImageSrc(photo2)} />
          ) : (
            <PhotoPlaceHolder isTicketExpired={isTicketExpired}>
              <FileInput
                name={shortlisted ? 'dimensionsImage' : 'photo2'}
                onChange={onAddPhoto}
                innerRef={photo2Ref}
                disabled={isSlipDiscarded}
              />
              <CustomAddIcon />
              <AddPhotoText>
                {shortlisted ? 'Dimensions diagram' : 'Add photo'}
              </AddPhotoText>
            </PhotoPlaceHolder>
          )}
        </InnerContainer>
        {shortlisted ? (
          <FieldImageName>Luminaire Dimensions</FieldImageName>
        ) : null}
      </ImgGrid>
    </Grid>
  </Container>
);

export default AddPhoto;
